import { type DecimalInput, Decimal, round2 } from './decimal';

/** Markup percent implied by a cost and a sell price: (sell − cost) / cost × 100. */
export function markupPercentFromPrices(costPrice: DecimalInput, sellPrice: DecimalInput): Decimal {
  const cost = new Decimal(costPrice);
  if (cost.isZero()) return new Decimal(0);
  return round2(new Decimal(sellPrice).minus(cost).dividedBy(cost).times(100));
}

/** Sell price implied by a cost and a markup percent: cost × (1 + percent / 100). */
export function priceFromMarkup(costPrice: DecimalInput, markupPercent: DecimalInput): Decimal {
  return round2(new Decimal(costPrice).times(new Decimal(1).plus(new Decimal(markupPercent).dividedBy(100))));
}
